import { html } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'

import { KlarnaBadge } from '../../assets/logos'
import {
  renderDefaultHTMLContent,
  renderMarkdownWithButton,
} from '../helpers/placementRendererHelper/placementRenderHelper'
import styles from './style.scss'

interface CreditPromotionBadgeProps {
  customStyles?: string
  theme?: string
  mainText?: string
  markdownContent?: string
  ctaLabel?: string
  legalText?: string
  onLearnMoreClick: () => null
  learnMoreClickAction: 'popup' | 'iframe'
}

export default function creditPromotionBadge({
  customStyles = '',
  theme = '',
  mainText = '',
  markdownContent = '',
  ctaLabel = '',
  legalText = '',
  onLearnMoreClick,
  learnMoreClickAction,
}: CreditPromotionBadgeProps) {
  return html`
    <style>
      ${styles}
    </style>
    ${html`${unsafeHTML(customStyles)}`}
    <div
      data-testid="${mainText ? 'credit-promotion-badge' : ''}"
      class="container ${theme}"
      part="osm-container"
    >
      <div class="badge-container">
        <div class="badge" part="osm-badge-container">${unsafeHTML(KlarnaBadge())}</div>
      </div>
      <div class="text-wrapper">
        ${markdownContent
          ? null
          : renderDefaultHTMLContent(
              mainText,
              ctaLabel,
              onLearnMoreClick,
              'DEFAULT',
              learnMoreClickAction
            )}
        ${renderMarkdownWithButton(
          markdownContent,
          ctaLabel,
          onLearnMoreClick,
          'DEFAULT',
          learnMoreClickAction
        )}
        ${legalText ? html`<p part="osm-legal" class="legal">${legalText}</p>` : ''}
      </div>
    </div>
  `
}
